import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnderlineTabsDirective } from './underline-tab/underline-tabs.directive';

@NgModule({
	declarations: [UnderlineTabsDirective],
	imports: [
		CommonModule
	],
	exports: [UnderlineTabsDirective]
})
export class TabsModule {}
